export default () => (to, from, next) => {
  const inviteCode = to.query['invite-code'];
  const { config } = window.__INITIAL_STATE__;

  // If no invite-code query param, allow through
  if (!inviteCode) {
    return next();
  }

  // Verify if invite codes are enabled and valid

  if (!config.inviteCodes.enabled) {
    return next();
  }

  const allowedCodes = `${config.inviteCodes.codes}`;
  const allowedCodesArray = allowedCodes.split(',').map((code) => code.trim());

  // Check if the invite code is valid
  if (!allowedCodesArray.includes(inviteCode)) {
    // Redirect to error page or handle invalid code
    return next({ path: '/trial-over' });
  }

  // Code is valid, proceed
  next();
};
